var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormContainer',{staticClass:"form-container--section",attrs:{"level":"section","button-text":"continuer","title":_vm.sectionTitle},on:{"click":function($event){return _vm.$emit('continue')}}},_vm._l((_vm.themes),function(ref){
var themeKey = ref[0];
var theme = ref[1];
return _c('ThemeCard',{key:("theme-" + themeKey),class:themeKey === 1 ? 'mt-5' : null,attrs:{"theme":theme,"is-selected":_vm.isThemeSelected(theme)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }